/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-15 10:36:40
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-15 10:40:39
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/utils/defineProps.ts
 */
/**
 * 定义对象属性
 * @param target 目标对象
 * @param optionKeyList 选项属性列表
 * @param materialKeyList 材质属性列表
 * @param updateFnName 更新函数名称
 */
export function defineProps(
  target: any,
  optionKeyList: string[],
  materialKeyList: string[],
  updateFnName = 'updateBox',
) {
  optionKeyList.forEach((key) => {
    Object.defineProperty(target, key, {
      get() {
        return this.currentOptions[key]
      },
      set(value: any) {
        this[updateFnName]({ [key]: value })
      },
      configurable: true,
      enumerable: true,
    })
  })
  materialKeyList.forEach((key) => {
    Object.defineProperty(target, key, {
      get() {
        return this.currentOptions.material?.[key]
      },
      set(value: any) {
        this[updateFnName]({ material: { [key]: value } })
      },
      configurable: true,
      enumerable: true,
    })
  })
}
